import React from 'react';

/**
 * ExpandMore icon component
 *
 * @param props - SVG props
 */
const ExpandMore: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width={12}
    height={12}
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M8.295 4.14746L6 6.43746L3.705 4.14746L3 4.85246L6 7.85246L9 4.85246L8.295 4.14746Z'
      fill='currentColor'
    />
  </svg>
);

export default ExpandMore;
